require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconLucideBell.tsx
var IconLucideBell_exports = {};
__export(IconLucideBell_exports, {
  default: () => IconLucideBell_default
});
module.exports = __toCommonJS(IconLucideBell_exports);

// src/assets/monochrome/lucideBell.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgLucideBell = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0001 2.41666C8.87289 2.41666 7.79188 2.86443 6.99485 3.66146C6.19782 4.45849 5.75006 5.53949 5.75006 6.66666C5.75006 9.69384 5.10036 11.6949 4.40848 12.9633C4.31926 13.1269 4.2296 13.2778 4.14091 13.4167H15.8592C15.7705 13.2778 15.6809 13.1269 15.5916 12.9633C14.8998 11.6949 14.2501 9.69384 14.2501 6.66666C14.2501 5.53949 13.8023 4.45849 13.0053 3.66146C12.2082 2.86443 11.1272 2.41666 10.0001 2.41666ZM17.9238 13.5478C17.923 13.5472 17.9216 13.5463 17.9198 13.5449C17.9122 13.5393 17.8962 13.527 17.8728 13.5075C17.826 13.4685 17.75 13.4007 17.6539 13.2993C17.4621 13.0969 17.1886 12.7585 16.9085 12.245C16.3504 11.2218 15.7501 9.47283 15.7501 6.66666C15.7501 5.14167 15.1443 3.67913 14.0659 2.6008C12.9876 1.52247 11.5251 0.916664 10.0001 0.916664C8.47506 0.916664 7.01253 1.52247 5.93419 2.6008C4.85586 3.67913 4.25006 5.14167 4.25006 6.66666C4.25006 9.47283 3.64976 11.2218 3.09164 12.245C2.81154 12.7585 2.53798 13.0969 2.34622 13.2993C2.25014 13.4007 2.17409 13.4685 2.12734 13.5075C2.10396 13.527 2.08788 13.5393 2.08028 13.5449C2.07647 13.5478 2.07479 13.5489 2.07536 13.5485L2.07795 13.5467L2.08054 13.545L2.08218 13.5439L2.08272 13.5435C1.80865 13.727 1.68662 14.0682 1.78224 14.384C1.87801 14.7003 2.16956 14.9167 2.50006 14.9167H17.5001C17.8306 14.9167 18.1221 14.7003 18.2179 14.384C18.3127 14.0707 18.1934 13.7324 17.9238 13.5478ZM2.08309 13.5433C2.08297 13.5433 2.08284 13.5434 2.08272 13.5435L2.08308 13.5433C2.08308 13.5433 2.08308 13.5433 2.08309 13.5433Z", fill: "#818898" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.22181 16.8428C8.58478 16.6432 9.0408 16.7757 9.24036 17.1387C9.31514 17.2747 9.42506 17.3881 9.55866 17.4671C9.69225 17.5461 9.84461 17.5878 9.99981 17.5878C10.155 17.5878 10.3074 17.5461 10.441 17.4671C10.5746 17.3881 10.6845 17.2747 10.7593 17.1387C10.9588 16.7757 11.4148 16.6432 11.7778 16.8428C12.1408 17.0423 12.2733 17.4984 12.0737 17.8613C11.8695 18.2327 11.5693 18.5425 11.2045 18.7582C10.8397 18.974 10.4236 19.0878 9.99981 19.0878C9.57598 19.0878 9.15993 18.974 8.79512 18.7582C8.43031 18.5425 8.13013 18.2327 7.92593 17.8613C7.72637 17.4984 7.85884 17.0423 8.22181 16.8428Z", fill: "#818898" })
] });
var lucideBell_default = SvgLucideBell;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconLucideBell.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconLucideBell = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(lucideBell_default, {}) });
};
IconLucideBell.displayName = "IconLucideBell";
var IconLucideBell_default = IconLucideBell;
